import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';

import { ClientePrazoPagamentoComponent } from './cliente-prazo-pagamento.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClientePrazoPagamentoComponent
    ],
    exports: [
        ClientePrazoPagamentoComponent
    ]
})
export class ClientePrazoPagamentoModule { }
